import { render, staticRenderFns } from "./TaxForm.vue?vue&type=template&id=2d1afaba&"
import script from "./TaxForm.vue?vue&type=script&lang=js&"
export * from "./TaxForm.vue?vue&type=script&lang=js&"
import style0 from "./TaxForm.vue?vue&type=style&index=0&id=2d1afaba&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1afaba')) {
      api.createRecord('2d1afaba', component.options)
    } else {
      api.reload('2d1afaba', component.options)
    }
    module.hot.accept("./TaxForm.vue?vue&type=template&id=2d1afaba&", function () {
      api.rerender('2d1afaba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Finance/TaxForm.vue"
export default component.exports